import Vue from 'vue'
import Router from 'vue-router'

console.log(window.location.href);
if(window.location.href==='https://www.uniceramics.com.cn//'){
  window.location.href="https://www.uniceramics.com.cn/"
}

Vue.use(Router)

/* Layout */
import Layout from '@/layout'


/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/404',
    redirect: '/index',
    component: () => import('@/views/404/404.vue'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    hidden: false,
    redirect: '/index',
    children: [{
      path: 'index',
      name: 'Index',
      component: () => import('@/views/index/index'),
      meta: { title: '首页', key:'sidebar.index', path: '/index' }
    }]
  },

  {
    path: '/about',
    component: Layout,
    children: [{
      path: '',
      name: 'about',
      component: () => import('@/views/dynamic/intro'),
      meta: { title: '关于我们', key:'sidebar.about', path: '/about' }
    }]
  },

  {
    path: '/dynamic',
    component: Layout,
    redirect: '/dynamic/news',
    meta: { title: '展会动态',key:'sidebar.dynamic',icon:require('@/assets/slidebar/001.jpg')},
    children: [
    // {
    //   path: 'intro',
    //   name: 'DynamicIntro',
    //   component: () => import('@/views/dynamic/intro'),
    //   meta: { title: '展会介绍', key:'sidebar.d_intro', path: '/dynamic/intro' }
    // },
    {
      path: 'news',
      name: 'DynamicNews',
      component: () => import('@/views/dynamic/news'),
      meta: { title: '展会新闻', key:'sidebar.d_news', path: '/dynamic/news' }
    },
    {
      path: 'media',
      name: 'DynamicMedia',
      component: () => import('@/views/dynamic/media'),
      meta: { title: '媒体报道', key:'sidebar.d_media', path: '/dynamic/media' }
    },
    {
      path: 'pic',
      name: 'DynamicPic',
      component: () => import('@/views/dynamic/pic'),
      meta: { title: '展会掠影', key:'sidebar.d_pic', path: '/dynamic/pic'}
    },
    {
      path: 'detail/:id',
      name: 'Detail',
      hidden:true,
      component: () => import('@/views/dynamic/detail'),
      meta: { title: '新闻详情', key:'sidebar.empty', path: '/dynamic/detail'}
    }]
  },
  // 英文版专用
  {
    path: '/news',
    component: Layout,
    children: [
    {
      path: '',
      name: 'News',
      hidden:true,
      component: () => import('@/views/dynamic/ennews'),
      meta: { title: 'news', key:'sidebar.ennews', path: '/news' }
    }
    ]
  },

  // {
  //   path: '/attend',
  //   component: Layout,
  //   children: [{
  //     path: '',
  //     name: 'AttendSign',
  //     component: () => import('@/views/attend/sign'),
  //     meta: { title: '观展登记', key:'sidebar.register', path: '/attend' }
  //   }]
  // },

  // {
  //   path: '/attend',
  //   component: Layout,
  //   redirect: '/attend/sign',
  //   meta: { title: '参展服务',icon:require('@/assets/slidebar/001.jpg')},
  //   children: [
  //   {
  //     path: 'sign',
  //     name: 'AttendSign',
  //     component: () => import('@/views/attend/sign'),
  //     meta: { title: '我要参展', path: '/attend/sign' }
  //   },
  //   {
  //     path: 'login',
  //     name: 'AttendLogin',
  //     component: () => import('@/views/attend/login'),
  //     meta: { title: '参展商登录', path: '/attend/login',disabled:true}
  //   }
  //   ]
  // },

  {
    path: '/service',
    component: Layout,
    children: [
    {
      path: '',
      name: 'Service',
      hidden:true,
      component: () => import('@/views/dynamic/service'),
      meta: { title: '观展服务', key:'sidebar.service', path: '/service' }
    }
    ]
  },

  {
    path: '/visit',
    component: Layout,
    children: [
    {
      path: '',
      name: 'VisitCourse',
      component: () => import('@/views/visit/course'),
      meta: { title: '文件下载', key:'sidebar.isit_course', path: '/visit' }
    }]
  },

  {
    path: '/live2',
    hidden:true,
    component: Layout,
    children: [{
      path: '',
      name: 'live',
      component: () => import('@/views/live/index'),
      meta: { title: '展会直播', key:'sidebar.live', path: '/live' }
    }]
  },

  // {
  //   path: '/visit',
  //   component: Layout,
  //   redirect: '/visit/sign',
  //   meta: { title: '观展服务',icon:require('@/assets/slidebar/003.jpg')},
  //   children: [{
  //     path: 'sign',
  //     name: 'VisitSign',
  //     component: () => import('@/views/visit/sign'),
  //     meta: { title: '我要报名', path: '/visit/sign' }
  //   },
  //   {
  //     path: 'course',
  //     name: 'VisitCourse',
  //     component: () => import('@/views/visit/course'),
  //     meta: { title: '观展指南', path: '/visit/course' }
  //   }]
  // },

  // {
  //   path: '/activity',
  //   component: Layout,
  //   redirect: '/activity/recommend',
  //   meta: { title: '活动推荐',icon:require('@/assets/slidebar/002.jpg')},
  //   children: [{
  //     path: 'recommend',
  //     name: 'ActivityRecommend',
  //     component: () => import('@/views/activity/recommend'),
  //     meta: { title: '活动预告', path: '/activity/recommend' }
  //   },
  //   {
  //     path: 'award',
  //     name: 'ActivityAward',
  //     component: () => import('@/views/activity/award'),
  //     meta: { title: '金樽奖', path: '/activity/award',disabled:true}
  //   },
  //   {
  //     path: 'detail/:id',
  //     name: 'Detail',
  //     hidden:true,
  //     component: () => import('@/views/activity/detail'),
  //     meta: { title: '活动详情', path: '/activity/detail'}
  //   }
  //   ]
  // },

  {
    path: '/contact',
    component: Layout,
    children: [{
      path: '',
      name: 'contact',
      component: () => import('@/views/contact/index'),
      meta: { title: '联系我们', key:'sidebar.contact', path: '/contact' }
    }]
  },

  //参展商与产品
  {
    path: '/seller',
    hidden:true,
    component: Layout,
    redirect: '/seller/list',
    children: [{
      path: 'list',
      name: 'Dynexhibitor',
      component: () => import('@/views/seller/list'),
      meta: { title: '参展商列表'}
    },
    {
      path: ':sid',
      name: '',
      component: () => import('@/views/seller/index'),
      meta: { title: '参展商主页' },
      redirect: '/seller/:sid/intro',
      children:[
        {
          path: 'intro',
          component: () => import('@/views/seller/child/intro'),
        },
        {
          path: 'product',
          component: () => import('@/views/seller/child/product'),
        },
        {
          path: 'product/:pid',
          component: () => import('@/views/seller/child/pdetail'),
        }
      ]
    }]
  },


  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
  { path: '', redirect: '/404', hidden: true }

]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }), //页面刷新时，滚动到顶部
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
